"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const adjustment_1 = require("services/adjustment");
const stockpile_types_1 = require("./stockpile.types");
const brand_1 = require("services/master-data/brand");
const contractor_1 = require("services/master-data/contractor");
const excavator_1 = require("services/master-data/excavator");
const pit_1 = require("services/master-data/pit");
const area_1 = require("services/master-data/area");
const seam_1 = require("services/master-data/seam");
const stockpile_1 = require("services/master-data/stockpile");
const stockpile_2 = require("services/stockpile");
const moment_1 = __importDefault(require("moment"));
const dump_truck_1 = require("services/master-data/dump-truck");
const getDataGridStockpile = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridAdjustmentStockpile)(dataStates);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            countData: response.countData,
            dataGrid: response.countData === 0
                ? []
                : response.data.map(item => {
                    return Object.assign(Object.assign({}, item), { time_in: new Date(item.gate_in), gate_in: new Date(item.gate_in), time_out: new Date(item.gate_out), gate_out: new Date(item.gate_out), created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), main_entrance_in: new Date(item.main_entrance_in), filename_penalty_evidence: item.image_penalty_evidence.length > 0
                            ? item.image_penalty_evidence.split('/')[item.image_penalty_evidence.split('/').length - 1]
                            : '' });
                })
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_MUTATION_CLICK, payload });
};
const onFilterChange = payload => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const getDataGridDeletedList = (dataStatesDeletedList) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridDeletedList)(dataStatesDeletedList);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            countData: response.countData,
            dataGridDeletedList: response.isError && response.data.length === 0
                ? []
                : response.data.map(item => {
                    return Object.assign(Object.assign({}, item), { modified_date: new Date(item.modified_date), main_entrance_in: new Date(item.main_entrance_in), gate_in: (0, moment_1.default)(item.gate_in).format('YYYY-MM-DD HH:mm') });
                })
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_GRID_DELETED_LIST, payload });
    }
});
const onDownloadTemplateDocument = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._downloadTemplateStockpile)(payload.type);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        window.open(response.url, '_blank');
        dispatch({
            type: stockpile_types_1.adjustmentStockpileTypes.ON_MUTATION_CLICK,
            payload: { mutationMode: payload.mutationMode, isLoadingDownload: false }
        });
    }
});
const onSortChangeDeletedList = payload => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_SORT_CHANGE_DELETED_LIST, payload });
};
const onFilterChangeDeletedList = payload => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_FILTER_CHANGE_DELETED_LIST, payload });
};
const onDataStateChangeDeletedList = (dataStatesDeletedList) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_PAGE_CHANGE_DELETED_LIST, payload: { dataStatesDeletedList } });
});
const onToggleLoading = (payload) => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_LOADING, payload });
};
const onDeleteStockpile = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._deleteAdjustmentStockpile)(payload);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_DELETE_STOCKPILE, payload: response });
    }
});
const onUploadManualStockpile = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    // Upload File Document
    const response_upload = yield (0, adjustment_1._uploadDocumentStockpile)(payload.formdata);
    if (response_upload.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response_upload });
    }
    else {
        // Upload Process Document
        const response_process = yield (0, adjustment_1._uploadProcessManual)(payload);
        if (response_process.isError) {
            dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response_process });
        }
        else {
            dispatch({
                type: stockpile_types_1.adjustmentStockpileTypes.ON_MUTATION_CLICK,
                payload: { mutationMode: false, isSuccess: true }
            });
        }
    }
});
const onUploadDocumentStockpile = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const [survey_doc] = payload.filter(item => item.doctype === 'survey');
    const [approval_doc] = payload.filter(item => item.doctype === 'approval');
    // Upload File Document Survey & Approval
    const response_survey = yield (0, adjustment_1._uploadDocumentStockpile)(survey_doc.formdata);
    const response_approval = yield (0, adjustment_1._uploadDocumentStockpile)(approval_doc.formdata);
    if (response_survey.isError || response_approval.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response_survey || response_approval });
    }
    else {
        // Upload Process Document
        const payload = {
            type: 'sc',
            filename: survey_doc.filename,
            justification: survey_doc.justification,
            filename_approval: approval_doc.filename,
        };
        const response_process = yield (0, adjustment_1._uploadProcessSurvey)(payload);
        if (response_process.isError) {
            dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response_process });
        }
        else {
            dispatch({
                type: stockpile_types_1.adjustmentStockpileTypes.ON_MUTATION_CLICK,
                payload: { mutationMode: false, isSuccess: true, isLoadingUpload: false }
            });
        }
    }
});
const getDataGridHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getGridUploadHistory)(dataStatesHistory);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            countData: response.countData,
            dataGridHistory: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { uploaded_at: new Date(item.uploaded_at) });
            })
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_GRID_HISTORY, payload });
    }
});
const getLastSucceedUpload = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const newDataStatesHistory = Object.assign(Object.assign({}, dataStatesHistory), { take: 1, sort: [{ field: 'uploaded_at', dir: 'desc' }], filter: {
            logic: 'and',
            filters: [
                { field: 'status', operator: 'contains', value: 'Success' },
            ]
        } });
    const response = yield (0, adjustment_1._getGridUploadHistory)(newDataStatesHistory);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            lastUpdated: response.data.length > 0 ? response.data[0].uploaded_at : null,
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_LAST_SUCCEED_UPLOAD, payload });
    }
});
const onSortChangeHistory = payload => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_SORT_CHANGE_HISTORY, payload });
};
const onFilterChangeHistory = payload => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_FILTER_CHANGE_HISTORY, payload });
};
const onDataStateChangeHistory = (dataStatesHistory) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_PAGE_CHANGE_HISTORY, payload: { dataStatesHistory } });
});
const getDataSummaryStockpile = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._getDataSummaryStockpile)(dataStates);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_SUMMARY, payload: response });
    }
});
const modifyStockpileTicket = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._modifyStockpileTicket)(payload);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.ON_MODIFY_TICKET_STOCKPILE, payload: response });
    }
});
const getDataDropdownPit = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'pit', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, pit_1._getMasterPit)(dataStates);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            dataDropdownPit: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_PIT, payload });
    }
});
const getDataDropdownArea = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'area_name', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, area_1._getMasterArea)(dataStates);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            dataDropdownArea: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_AREA, payload });
    }
});
const getDataDropdownSeam = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'seam', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, seam_1._getMasterSeam)(dataStates);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            dataDropdownSeam: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_SEAM, payload });
    }
});
const getDataDropdownBrand = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'code', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, brand_1._getBrandData)(dataStates);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            dataDropdownBrand: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_BRAND, payload: payload });
    }
});
const getDataDropdownContractor = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'contractor_name', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, contractor_1.getMasterContractor)(dataStates);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            dataDropdownContractor: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_CONTRACTOR, payload: payload });
    }
});
const getDataDropdownExcavator = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const dataStates = {
        skip: 0,
        total: 0,
        take: 1000,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'none',
        sort: [{ 'field': 'contractor_name', 'dir': 'asc' }],
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }]
        },
    };
    const response = yield (0, excavator_1._getMasterExcavator)(dataStates);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        const payload = {
            dataDropdownExcavator: response.countData === 0 ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_DATA_DROPDOWN_EXCAVATOR, payload });
    }
});
const getDetailCheckpoint = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, stockpile_1._getMasterStockpile)({
        skip: 0,
        take: 10000,
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }],
        },
        total: 0,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'scrollable',
        sort: [{ field: 'stockpile', dir: 'asc' }],
    });
    if (response.isError) {
        dispatch({
            type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Data Dropdown Master Silo. \n'.concat(response.errorMessage),
            },
        });
    }
    else {
        dispatch({
            type: stockpile_types_1.adjustmentStockpileTypes.GET_CHECKPOINT,
            payload: {
                dataCheckpoint: response.isError
                    ? []
                    : response.data.map((item) => {
                        return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date), checkpoint_name: item.stockpile, checkpoint_id: item.id });
                    }),
            },
        });
    }
});
const getDetailDumpTruck = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const responseDumpTruck = yield (0, dump_truck_1._getMasterDumpTruck)({
        skip: 0,
        take: 10000,
        filter: {
            logic: 'and',
            filters: [{ field: 'is_active', operator: 'eq', value: true }],
        },
        total: 0,
        sortable: false,
        filterable: false,
        reorderable: false,
        scrollable: 'scrollable',
        sort: [{ field: 'dumptruck_no', dir: 'asc' }],
    });
    const dataDumpTruck = responseDumpTruck.data.sort(({ dumptruck_no: a }, { dumptruck_no: b }) => Number(a) - Number(b));
    dispatch({
        type: stockpile_types_1.adjustmentStockpileTypes.GET_DUMPTRUCK,
        payload: {
            dataDumptruck: dataDumpTruck,
            dataItem: payload.dataItem
        },
    });
});
const savePassiveData = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f, _g;
    const { dataItem, transaction_type } = payload;
    const response = yield (0, stockpile_2._createTransactionStockpile)({
        transaction_type: transaction_type == 'ticket adjustment' ? 'manual' : 'survey_correction',
        penalty: '0',
        is_active: true,
        image_penalty_evidence: '',
        seam_id: ((_a = dataItem.seam) === null || _a === void 0 ? void 0 : _a.id) || '',
        area_id: ((_b = dataItem.area) === null || _b === void 0 ? void 0 : _b.id) || '',
        brand_id: ((_c = dataItem.brand) === null || _c === void 0 ? void 0 : _c.id) || '',
        excavator_id: ((_d = dataItem.excavator) === null || _d === void 0 ? void 0 : _d.id) || '',
        dumptruck_id: ((_e = dataItem.dump_truck) === null || _e === void 0 ? void 0 : _e.id) || '',
        contractor_id: ((_f = dataItem.contractor) === null || _f === void 0 ? void 0 : _f.id) || '',
        capacity_volume: dataItem.capacity_volume,
        pit_id: ((_g = dataItem.pit) === null || _g === void 0 ? void 0 : _g.id) || '',
        nett_volume: dataItem.capacity_volume,
        pos_id: dataItem.checkpoint.checkpoint_id,
        gate_in: (0, moment_1.default)(dataItem.gate_in).format(),
        gate_out: dataItem.gate_out,
        main_entrance_in: dataItem.main_entrance_in,
        ticket_no: (0, moment_1.default)(dataItem.gate_in).format('YYYYMMDD')
            + (transaction_type === 'ticket adjustment' ? 'D' : 'E') + 'PXXXXX',
    });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({
            type: stockpile_types_1.adjustmentStockpileTypes.ON_SAVE_DATAITEM,
            payload: {
                dataItem, isError: !isSuccess, errorCode: response.errorCode, errorMessage: response.errorMessage
            },
        });
    }
    else {
        dispatch({
            type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR,
            payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }),
        });
    }
});
const clearDocumentsStockpile = () => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.CLEAR_EXPORT_DOCUMENTS_URL, payload: '' });
};
const exportAdjustmentStockpile = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, adjustment_1._exportAdjustmentStockpile)(dataStates);
    if (response.isError) {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_ERROR, payload: response });
    }
    else {
        dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_EXPORT_DOCUMENTS_URL, payload: response });
    }
});
const onLoadingExportExcel = () => dispatch => {
    dispatch({ type: stockpile_types_1.adjustmentStockpileTypes.SET_LOADING_EXPORT_EXCEL, payload: true });
};
exports.default = {
    onCloseError,
    onClickMutation,
    onToggleLoading,
    onSortChange,
    onFilterChange,
    onDataStateChange,
    getDataGridStockpile,
    getDataGridDeletedList,
    onSortChangeDeletedList,
    onFilterChangeDeletedList,
    onDataStateChangeDeletedList,
    onLoadingExportExcel,
    clearDocumentsStockpile,
    onUploadManualStockpile,
    exportAdjustmentStockpile,
    onUploadDocumentStockpile,
    onDownloadTemplateDocument,
    onDeleteStockpile,
    getLastSucceedUpload,
    modifyStockpileTicket,
    getDataSummaryStockpile,
    getDataGridHistory,
    onSortChangeHistory,
    onFilterChangeHistory,
    onDataStateChangeHistory,
    getDetailDumpTruck,
    getDataDropdownPit,
    getDataDropdownArea,
    getDetailCheckpoint,
    getDataDropdownSeam,
    getDataDropdownBrand,
    getDataDropdownExcavator,
    getDataDropdownContractor,
    savePassiveData
};
